import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvProgramEditor.html?raw';
import "../EvBookingEditorTypes";
import '../../../moreCore/UI/DateTimeInput/DateTimeInput';
import Edit from '../../../moreCore/UI/Edit/Edit';
import '../../../moreCore/UI/Edit/Edit';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import '../../../moreCore/UI/CheckBox/CheckBox';
import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import "../../../moreCore/UI/SearchSelect/SearchSelect";
import "../../../moreCore/UI/_StatefulBase/_StatefulBase";
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';


interface RedEntry {
    ID: string,
    Classname: string,
    c_composer_author: string,
    c_opus: string,
    duration_min: number,
    state: string,
    is_red_entry: boolean,
    order: number,
}
class EvProgramEditor extends compose(_WidgetBaseSP) {
	templateString: any = template;
    opusInput: MdsLax<InstanceType<typeof HintBox>>;
    isRedEntry: MdsLax<InstanceType<typeof CheckBox>>;
    opusRedInput_Author: MdsLax<InstanceType<typeof Edit>>;
    opusRedInput_Title: MdsLax<InstanceType<typeof Edit>>;
    opusRedInput_Duration: MdsLax<InstanceType<typeof NumberInput>>;

    opusInputContainer: HTMLElement;
    redEntryInputContainer: HTMLElement;
    addRedEntryButton: HTMLButtonElement;

    redEntry: RedEntry;


    private emitAddedEvent(value: any, source: "hintbox" | "redEntry"): void {

        if (value != null) {
            this.emit("added", value, [EvBookingEditor_ListNames.EvProgram]);

            switch (source) {
                case "hintbox":
                    this.opusInput.setValue(null);
                    break;
                case "redEntry":
                    this.opusRedInput_Author.setValue(null);
                    this.opusRedInput_Title.setValue(null);
                    this.opusRedInput_Duration.setValue(null);
                    break;
            }
        }
    }

    private _onChangeIsRedEntry(isRed: boolean): void {
        
        this.UiModder.domClass.toggle(this.redEntryInputContainer, "w3-hide", isRed === false);
        this.UiModder.domClass.toggle(this.opusInputContainer, "w3-hide", isRed === true);
    }

    _onChangeOpusInput(): void {
        let value = this.opusInput.getValue();

        this.emitAddedEvent(value, "hintbox");
    }

    private _onChangeRedInput(value: any): void {

        if (value != null) this.redEntry = {
            ID: null,
            Classname: "opus",
            is_red_entry: true,
            order: null,
            state: "new",
            c_composer_author: this.opusRedInput_Author.getValue(),
            c_opus: this.opusRedInput_Title.getValue(),
            duration_min: this.opusRedInput_Duration.getValue()
        };

        let readyCheck = this.opusRedInput_Author.getValue() ||
            this.opusRedInput_Title.getValue();
            //this.opusRedInput_Author.getValue() ||
            //this.opusRedInput_Duration.getValue() != null;

        this.UiModder.domClass.toggle(this.addRedEntryButton, "w3-disabled", !readyCheck);
    }

    private _onClickAddRedEntryButton(): void {
        
        this.emitAddedEvent(this.redEntry, "redEntry");
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.UiModder.domClass.add(this.opusRedInput_Author.inputNode, "w3-text-red");
        this.UiModder.domClass.add(this.opusRedInput_Title.inputNode, "w3-text-red");
        this.opusRedInput_Duration.enableKeyUpEvent(true);

        this.domNode.addEventListener('click', function (evt) {

            evt.stopPropagation();

        });
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvProgramEditor);